import { PersonalizationNotCompletedPayload } from '@/core';
import { Button, Modal, Space } from 'antd';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';

interface Props {
  errorPayload: PersonalizationNotCompletedPayload;
  onClose: () => any;
}

export function PersonalizationNotCompletedModal(props: Props) {
  const { onClose } = props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'pricing.notCompletedModal',
  });

  const { notCompletedCategories } = props.errorPayload;

  return (
    <Modal
      title={t('title')}
      visible
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          {t('close')}
        </Button>,
      ]}
    >
      <Space direction="vertical" size="large">
        {!isEmpty(notCompletedCategories) && (
          <div>
            {t('notCompletedCategories.header')}
            <ul className="mt-2">
              {notCompletedCategories.map(
                ({ name, max, min, count: currentCount }, index) => (
                  <li key={index}>
                    {t('notCompletedCategories.title', {
                      name,
                      max,
                      min,
                      currentCount,
                    })}
                  </li>
                ),
              )}
            </ul>
          </div>
        )}
      </Space>
    </Modal>
  );
}
